// extracted by mini-css-extract-plugin
export default {"container":"Yt5AvuH2CpgZpW9FQLuv","titleBlock":"GUhs56age63df5Bf7t1W","buttons":"mxDu0P2zoSzijb8yoR7I"};